export enum StepStatusEnum {
  SKIPPED = 'skipped',
  COMPLETED = 'completed',
  REJECTED = 'rejected',
  PENDING = 'pending',
  INPROGRESS = 'in_progress',
  NOT_STARTED = 'not_started',
  REASSIGN = 're_assign',
  SENT_BACK = 'sent_back',
  SENT_FORWARD = 'sent_forward',
  NO_ACTION = 'no_action',
  ON_HOLD = 'on_hold',
  SCHEDULED = 'scheduled',
  CANCELLED = 'cancelled',
  EDITED = 'edited',
}
